import { useLocale } from "@/contexts/LocaleContext";

const COLORS = {
  pending: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  accepted: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  approved: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  rejected: "bg-red-500/15 text-red-500 border-red-500/30",
  counter: "bg-accent/15 text-accent border-accent/30",
  closed: "bg-muted text-muted-foreground border-border",
  new: "bg-accent/15 text-accent border-accent/30",
  contacted: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  published: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  paused: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  draft: "bg-muted text-muted-foreground border-border",
  sold: "bg-accent/15 text-accent border-accent/30",
  expired: "bg-red-500/15 text-red-500 border-red-500/30",
  active: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  archived: "bg-muted text-muted-foreground border-border",
  confirmed: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  cancelled: "bg-red-500/15 text-red-500 border-red-500/30",
  completed: "bg-accent/15 text-accent border-accent/30",
  preparing: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  shipped: "bg-sky-500/15 text-sky-500 border-sky-500/30",
  delivered: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  unavailable: "bg-red-500/15 text-red-500 border-red-500/30",
};

export function StatusBadge({ status }) {
  const { t } = useLocale();
  const cls = COLORS[status] || "bg-muted text-muted-foreground border-border";
  const label = t(`status.${status}`) || status;
  return (
    <span className={`px-2 py-0.5 text-[10px] font-mono-data uppercase tracking-wider border ${cls}`}>
      {label}
    </span>
  );
}
